import { TFunction } from 'i18next';
import { SAPContact } from '../../types';

export interface ManualSearchState {
  contacts: SAPContact[];
  isLoading: boolean;
  error?: string;
}

export function getSapContactDisplayName(contact: SAPContact, t: TFunction): string {
  if (contact.type === 'corporate') {
    return contact.accountName || t('call:sap.unknownCompany');
  }
  return `${contact.firstName} ${contact.lastName}`.trim() || t('call:sap.unknownContact');
}
